export const getTicketId = (ticket = {}) =>
  ticket.dataFromSwarm?.id ?? ticket.id ?? ticket.dataFromCasino?.CasinoTransactionId;
